export default function () {
  return [
    {
      title: {
        pl: 'Strona główna',
        en: 'Homepage'
      },
      to: '/kokpit',
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: '',
      permission: 'home'
    },
    {
      title: {
        pl: 'Zamówienia',
        en: 'Orders'
      },
      to: '/zamowienia',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permission: 'orders'
    },
    {
      title: {
        pl: 'Oferty',
        en: 'Offers'
      },
      to: '/oferty',
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: '',
      permission: 'orders'
    },
    {
      title: {
        pl: 'Klienci',
        en: 'Customers'
      },
      to: '/klienci',
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
      permission: 'partner_customers'
    },
    {
      title: {
        pl: 'Rozliczenia',
        en: 'Settlements'
      },
      to: '/rozliczenia',
      htmlBefore: '<i class="material-icons">attach_money</i>',
      htmlAfter: '',
      permission: 'settlements'
    },
    {
      title: {
        pl: 'Cenniki',
        en: 'Prices'
      },
      htmlBefore: '<i class="material-icons">monetization_on</i>',
      htmlAfter: '',
      permission: 'partner_users',
      items: [
        {
          title: {
            pl: 'Cenniki produktów',
            en: 'Products prices'
          },
          to: '/cenniki/produkty'
        },
        {
          title: {
            pl: 'Cenniki zdobień',
            en: 'Services prices'
          },
          to: '/cenniki/zdobienia'
        },
        {
          title: {
            pl: 'Cenniki setup',
            en: 'Setup prices'
          },
          to: '/cenniki/setup'
        }
      ]
    },
    {
      title: {
        pl: 'Użytkownicy',
        en: 'Users'
      },
      to: '/uzytkownicy',
      htmlBefore: '<i class="material-icons">person</i>',
      htmlAfter: '',
      permission: 'partner_users'
    },
    {
      title: {
        pl: 'Twoje konto',
        en: 'Your account'
      },
      to: '/moje-konto',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permission: 'profile'
    },
    {
      title: {
        pl: 'Tłumaczenia',
        en: 'Translations'
      },
      to: '/tlumaczenia',
      htmlBefore: '<i class="material-icons">language</i>',
      htmlAfter: '',
      permission: 'settings'
    },
    {
      title: {
        pl: 'Wyloguj się',
        en: 'Logout'
      },
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj',
      permission: false
    }
  ];
}
